import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { LinkContainer } from 'react-router-bootstrap';
import cx from 'classnames';

// Components.
import UserProfilePictureModal from 'components/UserProfilePictureModal';

// Styles.
import styles from './styles.module.scss';

// Images.
import { ReactComponent as DefaultUserPicture } from './images/default-user-picture.svg';

export default class UserPicture extends PureComponent {

  static propTypes = {
    profile: PropTypes.object.isRequired,
    className: PropTypes.string,
    link: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.string,
    ]),
    onClick: PropTypes.func,
    isShowModal: PropTypes.bool
  };

  static defaultProps = {
    isShowModal: true
  }

  state = {
    userpic: this.props.profile?.userpic,
    userPictureVisible: false,
    userPickWidthImage: false,
    userPickHeightImage: false,
    isShowUserProfilePictureModal: false,
  };

  onLoadUserPick = () => {
    this.preRenderUserPick();
  };

  preRenderUserPick = () => {
    if (!this.userPictureDiv) {
      return;
    }
    const userPick = this.userPictureDiv.getElementsByTagName('img');
    if (userPick !== undefined) {
      const naturalWidth = userPick[0].naturalWidth;
      const naturalHeight = userPick[0].naturalHeight;
      if (naturalWidth > naturalHeight) {
        this.setState({ userPickWidthImage: true, userPickHeightImage: false });
      }
      else if (naturalWidth < naturalHeight) {
        this.setState({ userPickHeightImage: true, userPickWidthImage: false });
      }
      this.setState({ userPictureVisible: true });
    }
  };


  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.isFetchedProfile !== nextProps.isFetchedProfile && nextProps.isFetchedProfile === true) {
      return { 
        userpic: nextProps.profile?.userpic
      };
    }
  }

  onClickUserProfilePictureModal = () => {
    if (this.props.isShowModal === false) {
      return;
    }
    this.setState({ isShowUserProfilePictureModal: !this.state.isShowUserProfilePictureModal });
  };

  onDropUserProfilePhoto = (formData, userProfilePhotoPreview) => {
    this.setState({ isShowUserProfilePictureModal: false }, () => {
      this.props.onDropUserProfilePhoto(formData, userProfilePhotoPreview);
    })
  };

  onDrop = (files) => {
    if (!files || files.length === 0) {
      return;
    }
    const userProfilePhoto = files[0];
    const profile = { ...this.state.profile, userpic: userProfilePhoto.preview };
    this.setState({ profile: profile, isShowUserProfilePictureModal: false }, () => {
      const formData = new FormData();
      formData.append('userpic', userProfilePhoto);
      this.props.onDropUserProfilePhoto(formData, userProfilePhoto.preview);
    });
  };


  render() {
    const { profile, link, className } = this.props;
    let userpick = (
      <>
        <DefaultUserPicture />
        <span>Upload a profile picture</span>
      </>
    );
    let isUserPickExist = false;
    if (profile?.userpic) {
      userpick = <img src={profile.userpic} onLoad={this.onLoadUserPick} />;
      isUserPickExist = true;
    }
    let content = userpick;
    if (link) {
      content = (
        <LinkContainer to="/user/profile">
          {userpick}
        </LinkContainer>
      );
    }
    const userPictureClasses = cx(
      styles.userPicture,
      { [styles.userPickWidthImage]: this.state.userPickWidthImage },
      { [styles.userPickHeightImage]: this.state.userPickHeightImage },
      { [styles.userPictureVisible]: this.state.userPictureVisible },
      { [styles.userPickWithImage]: isUserPickExist },
      { [styles.userPickWithoutImage]: !isUserPickExist },
      { [styles.userPickLink]: link },
      { [styles.noLink]: this.props.isShowModal === false}
    );
    return (
      <div className={cx(styles.userPictureWrapper, className)} onClick={this.onClickUserProfilePictureModal}>
        <div ref={userPictureDiv => this.userPictureDiv = userPictureDiv} className={userPictureClasses}>
          {content}
        </div>
        {this.props.isShowModal === true &&
          <UserProfilePictureModal
            profile={profile}
            onDropUserProfilePhoto={this.onDropUserProfilePhoto}
            onDrop={this.onDrop}
            isShowUserProfilePictureModal={this.state.isShowUserProfilePictureModal}
            onClickUserProfilePictureModal={this.onClickUserProfilePictureModal}
          />
        }
      </div>
    );
  }

}
